import { render, staticRenderFns } from "./BmscFile.vue?vue&type=template&id=bcecee6e&scoped=true&"
import script from "./BmscFile.vue?vue&type=script&lang=js&"
export * from "./BmscFile.vue?vue&type=script&lang=js&"
import style0 from "./BmscFile.vue?vue&type=style&index=0&id=bcecee6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcecee6e",
  null
  
)

export default component.exports